import { render } from "./taxCalculatorComponent.vue?vue&type=template&id=4a6957f8"
import script from "./taxCalculatorComponent.vue?vue&type=script&lang=js"
export * from "./taxCalculatorComponent.vue?vue&type=script&lang=js"

import "./taxCalculatorComponent.vue?vue&type=style&index=0&id=4a6957f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__